import React from "react";
import { Row, Col } from "antd";
import "../../assets/css/footer.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faFacebookF,
  faInstagram,
  faLinkedinIn,
  faYoutube,
  faWhatsapp,
} from "@fortawesome/free-brands-svg-icons";


import logo from "../../assets/images/2025/Logos_Botones_Iconos/casaduana_LogoFooter.svg";
import logo_wdp from "../../assets/images/2025/Logos_Botones_Iconos/whatsapp.svg";

const brands = { faFacebookF, faInstagram, faLinkedinIn, faYoutube };


const Footer = () => {
  return (
    <div style={{ backgroundColor: "#134472" }}>
      {/* --- BLOQUE SUPERIOR --- */}
      <Row
        justify="center"
        style={{
          padding: "50px 0",
          textAlign: "center",
          borderBottom: "1px solid rgba(255,255,255,0.2)",
        }}
      >
        <Col xs={22} md={20}>
          <Row gutter={[50, 40]} justify="space-between">
            {/* LOGO */}
            <Col xs={24} md={8}>
              <a href="https://casaduana.com/" target="_blank" rel="noreferrer">
                <img src={logo} alt="casaduana logo" style={{ width: 160 }} />
              </a>
            </Col>

            {/* CONTACTO */}
<Col xs={24} md={8}>
  <div
    style={{
      textAlign: "center",
      padding: "10px 0",
    }}
  >
    <p
      style={{
        color: "#fff",
        margin: 0,
        fontSize: 15,
        opacity: 0.9,
      }}
    >
      ¿Tienes dudas?
    </p>

    <a
      href="https://api.whatsapp.com/send?phone=528671262082"
      target="_blank"
      rel="noreferrer"
      className="link_footer color_blanco"
      style={{
        fontSize: 18,
        fontWeight: 600,
        display: "inline-flex",
        alignItems: "center",
        gap: 10,
      }}
    >
      <FontAwesomeIcon
        icon={faWhatsapp}
        style={{ fontSize: 26, color: "#ffffff" }}
      />
      +52 867 126 2082
    </a>
  </div>
</Col>


           {/* REDES */}
<Col xs={24} md={8}>
  <Row justify="center" gutter={[20, 20]}>
    {[
      { icon: "faFacebookF", url: "https://www.facebook.com/casaduana.mx/" },
      { icon: "faInstagram", url: "https://www.instagram.com/casaduana/?hl=es" },
      { icon: "faLinkedinIn", url: "https://mx.linkedin.com/company/mejia-y-sucesores-s-c" },
      { icon: "faYoutube", url: "https://www.youtube.com/channel/UCOPkJY7NRSxK0w9XDQp2GBA?app=desktop" },
    ].map((r, i) => (
      <Col key={i}>
        <a
          href={r.url}
          target="_blank"
          rel="noopener noreferrer"
          className="social-circle"
        >
          <FontAwesomeIcon icon={brands[r.icon]} />
        </a>
      </Col>
    ))}
  </Row>
</Col>


          </Row>
        </Col>
      </Row>

      {/* --- BLOQUE INFERIOR --- */}
      <Row justify="center" style={{ padding: "20px 0" }}>
        <span className="leyenda color_blanco" style={{ fontSize: 12 }}>
          © 2025 · agencialacolmena.com · Todos los derechos reservados
        </span>
      </Row>
    </div>
  );
};

export default Footer;
